(
    function (skyward, $, undefined)
    {
        skyward.officevisit = skyward.officevisit || {};

        var Module;
        var LatestTimeTransactionID;

        var init = function (selector)
        {
            if ($(selector).find(".officevisit").length > 0)
            {
                var parent = $(selector).find(".officevisit");
                Module = parent.hasClass("health") ? "Health" : "Guidance";

                $(parent).find('#btnAddToWaitingList').on('click', skyward.officevisit.addtowaitinglist);
                $(parent).find('#btnAddToInOffice').on('click', skyward.officevisit.addtoinoffice);
                $(parent).find('#btnRelease').on('click', skyward.officevisit.release);
                $(parent).find('#btnReleaseComplete').on('click', skyward.officevisit.releasecomplete);
                $(parent).find('#btnComplete').on('click', skyward.officevisit.complete);

                //Sync Latest Time Transaction
                LatestTimeTransactionID = skyward.controls.getValue($(parent).find('#LatestTimeTransactionID'));

                (parent).find('#StartTimeDate-' + LatestTimeTransactionID).on('change', skyward.officevisit.synclatesttimetransaction);
                (parent).find('#StartTime-' + LatestTimeTransactionID).on('change', skyward.officevisit.synclatesttimetransaction);
                (parent).find('#EndTime-' + LatestTimeTransactionID).on('change', skyward.officevisit.synclatesttimetransaction);
            }

            if ($(selector).find(".officevisitqueue").length > 0)
            {
                var studentOfficeVisitQueueParent = $(selector).find(".officevisitqueue");
                Module = studentOfficeVisitQueueParent.hasClass("health") ? "Health" : "Guidance";

                skyward.officevisit.officevisitqueuebuttonreadonlyinitialize(studentOfficeVisitQueueParent);
                if (Module == 'Guidance')
                {
                    $(studentOfficeVisitQueueParent).find('#studentSelectorTileViewEEL').on('change', skyward.officevisit.officevisitqueuestudentbuttonreadonly);
                }
                else
                {
                    $(studentOfficeVisitQueueParent).find('#studentSelectorTileViewEEL').on('change', skyward.officevisit.officevisitqueuenamebuttonreadonly);
                    $(studentOfficeVisitQueueParent).find('#staffSelectorTileViewEEL').on('change', skyward.officevisit.officevisitqueuenamebuttonreadonly);
                }
                $(studentOfficeVisitQueueParent).find('#btnAddToInOffice').on('click', skyward.officevisit.addtoinofficequeue);
                $(studentOfficeVisitQueueParent).find('#btnAddToWaitingList').on('click', skyward.officevisit.addtowaitinglistqueue);

                $(selector).find('.btnGetStudentLocationStudentProfile').on('click', skyward.officevisit.getStudentLocationStudentProfile);
                $(selector).find('.btnGetStudentLocationOfficeVisitQueue').on('click', skyward.officevisit.getStudentLocationOfficeVisitQueue);

                resizeOfficeVisitQueueBrowse();
                skyward.window.registerLayoutResizeCallback(resizeOfficeVisitQueueBrowse);
            }
        };

        skyward.officevisit.addtowaitinglist = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnAddToWaitingList').data();
            saveActions("AddToWaiting", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.addtoinoffice = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnAddToInOffice').data();
            saveActions("AddToInOffice", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.release = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnRelease').data();
            saveActions("Release", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.releasecomplete = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnReleaseComplete').data();
            saveActions("ReleaseCompleteLater", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.complete = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnComplete').data();
            saveActions("Complete", clickedButton, false, buttonInfo);
        };

        var saveActions = function (action, clickedButton, allowGoBack, buttonInfo)
        {
            var controller = Module == "Guidance" ? "StudentOfficeVisit" : "NameOfficeVisit";

            $("#edit" + controller + "_save").addClass("dirty");

            var id = clickedButton.data("primarykey");
            var detailsPanel = clickedButton.parents('#detailsPanel');
            var isDetailsPanel = detailsPanel.length > 0;

            skyward.dataobjectviewer.save('edit' + controller, Module, controller, "Details", id, 'null', action, (allowGoBack && !isDetailsPanel), "General", isDetailsPanel, false).done(function ()
            {
                var redirectURL = buttonInfo.urlreferrer;
                if (redirectURL != null)
                {
                    var mvc =
                    {
                        controller: controller,
                        action: redirectURL.includes("StudentProfile") ? "StudentProfile" : "OfficeVisitQueue",
                        id: id,
                        studentID: buttonInfo.studentid
                    };

                    var redirectID = mvc.action == "StudentProfile" ? buttonInfo.studentID : id;

                    $.ajax(
                    {
                        type: "POST",
                        url: skyward.global.virtualDir + Module + "/" + controller + "/" + mvc.action + "/" + redirectID,
                        data: mvc,
                        success: function ()
                        {
                            skyward.window.loadContent("full", Module, controller, mvc.action, redirectID, mvc);
                        }
                    });
                }
            });
        };

        skyward.officevisit.synclatesttimetransaction = function ()
        {
            var sourceElement = $(this);
            var parent = sourceElement.parents('.officevisit').first();
            var value = skyward.controls.getValue(sourceElement);

            if (sourceElement.attr('id') == '#StartTimeDate-' + LatestTimeTransactionID)
            {
                syncField(parent.find('#LatestStartDate'), value);
            }
            else if (sourceElement.attr('id') == 'StartTime-' + LatestTimeTransactionID)
            {
                syncField(parent.find('#LatestStartTime'), value);
            }
            else if (sourceElement.attr('id') == 'EndTime-' + LatestTimeTransactionID)
            {
                syncField(parent.find('#LatestEndTime'), value);
            }
        };

        var syncField = function (targetElement, value)
        {
            targetElement.off('change', skyward.officevisit.synclatesttimetransaction);
            skyward.controls.setValue(targetElement, value);
            targetElement.on('change', skyward.officevisit.synclatesttimetransaction);
        };

        skyward.officevisit.officevisitqueuebuttonreadonlyinitialize = function ()
        {
            skyward.controls.hide('btnStudentInformationPopup');
            skyward.controls.hide('btnAddToInOffice');
            skyward.controls.hide('btnAddToWaitingList');
            skyward.controls.setValue('label.OfficeVisitStudentLocation', '', true);
        };

        skyward.officevisit.officevisitqueuenamebuttonreadonly = function ()
        {
            var textbox = $(this);
            var parentDiv = textbox.parents('div#StudentStaffSearchContainer');
            var nameOfficeVisitFilterOption = skyward.controls.getValue('#NameOfficeVisitFilterOption');
            var primaryKey;

            skyward.controls.setValue('label.OfficeVisitStudentLocation', '', true);

            var studentName = "";
            var studentID = "";

            if (nameOfficeVisitFilterOption == 'STU')
            {
                primaryKey = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_value'));
                studentID = primaryKey;
                studentName = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_code'));
                title = studentName;
                skyward.controls.show('btnStudentInformationPopup');
            }
            else if (nameOfficeVisitFilterOption == 'STF')
            {
                primaryKey = skyward.controls.getValue('#staffSelectorTileViewEEL_value');
                skyward.controls.hide(studentLocationDiv);
            }

            var studentPopupButton = parentDiv.find('#btnStudentInformationPopup');
            var studentLocationDiv = parentDiv.siblings('div#studentLocationDiv');

            if (primaryKey != "")
            {
                if (nameOfficeVisitFilterOption == 'STU')
                {
                    $.ajax({
                        url: skyward.global.virtualDir + Module + "/NameOfficeVisit/OfficeVisitQueueGetStudentName/",
                        type: "POST",
                        dataType: "JSON",
                        data: { StudentID: primaryKey },
                        success: function (data)
                        {
                            if (data != null && studentID != "")
                            {
                                studentPopupButton.data('id', studentID);
                                studentPopupButton.data('primarykey', studentID);
                                studentPopupButton.data('title', studentName);
                            }
                        }
                    });
                }

                skyward.controls.show('btnAddToInOffice');
                skyward.controls.show('btnAddToWaitingList');
            }
            else
            {
                skyward.controls.hide('btnStudentInformationPopup');
                skyward.controls.hide('btnAddToInOffice');
                skyward.controls.hide('btnAddToWaitingList');
            }

            resizeOfficeVisitQueueBrowse();
        };

        skyward.officevisit.getStudentLocationStudentProfile = function ()
        {
            var clickedButton = $(this);
            var locationTextbox = clickedButton.siblings('input.OfficeVisitStudentLocation');
            var controller;
            if (Module == "Guidance")
            {
                controller = "StudentOfficeVisit";
            }
            else
            {
                controller = "NameOfficeVisit";
            }
            
            var data = clickedButton.data();
            var studentID;
            var entityID;
            var schoolYearID;

            if (data.studentId != null)
            {
                studentID = data.studentId;
            }
            if (data.entityId != null)
            {
                entityID = data.entityId;
            }
            if (data.schoolYearId != null)
            {
                schoolYearID = data.schoolYearId;
            }

            skyward.officevisit.commonStudentLocation(locationTextbox, studentID, entityID, schoolYearID, controller, "StudentProfile");
        };

        skyward.officevisit.getStudentLocationOfficeVisitQueue = function ()
        {
            var clickedButton = $(this);
            var locationTextbox = clickedButton.siblings('label.OfficeVisitStudentLocation');
            var controller;            

            var data = clickedButton.data();
            var studentID;
            var entityID;
            var schoolYearID;

            if (data.entityId != null)
            {
                entityID = data.entityId;
            }
            if (data.schoolYearId != null)
            {
                schoolYearID = data.schoolYearId;
            }

            var searchContainerName;
            if (Module == "Guidance")
            {
                controller = "StudentOfficeVisit";
                searchContainerName = 'div#StudentSearchContainer';
            }
            else
            {
                controller = "NameOfficeVisit";
                searchContainerName = 'div#StudentStaffSearchContainer';
            }
            var parentFieldset = clickedButton.parent('div#studentLocationDiv');
            var tileViewParent = parentFieldset.siblings(searchContainerName);
            studentID = skyward.controls.getValue(tileViewParent.find('#studentSelectorTileViewEEL_value'));

            skyward.officevisit.commonStudentLocation(locationTextbox, studentID, entityID, schoolYearID, controller, "OfficeVisitQueue");
        };

        skyward.officevisit.commonStudentLocation = function (locationElement, studentID, entityID, schoolYearID, controller, screen)
        {
            if (studentID != null && entityID != null && schoolYearID != null)
            {
                $.ajax({
                    url: skyward.global.virtualDir + Module + "/" + controller + "/GetStudentLocation" + screen + "/",
                    type: "POST",
                    dataType: "JSON",
                    data:
                        {
                            studentID: studentID,
                            entityID: entityID,
                            schoolYearID: schoolYearID
                        },
                    success: function (returnData)
                    {
                        skyward.controls.setValue(locationElement, returnData.StudentLocation, true);
                    }
                });
            }
        };

        skyward.officevisit.officevisitqueuestudentbuttonreadonly = function () {
            var textbox = $(this);
            var parentDiv = textbox.parent('div');
            var studentID = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_value'));
            var studentName = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_code'));
            var studentPopupButton = parentDiv.find('#btnStudentInformationPopup');
            var studentLocationLabel = parentDiv.parent('div').find('#locationDivOfficeVisitQueue').find('#studentLocationLabel');

            skyward.controls.setValue('label.OfficeVisitStudentLocation', '', true);

            if (studentID != "") {
                $.ajax({
                    url: skyward.global.virtualDir + Module + "/StudentOfficeVisit/OfficeVisitQueueGetStudentLocation/",
                    type: "POST",
                    dataType: "JSON",
                    data: { StudentID: studentID },
                    success: function (data) {
                        if (data != null && data.studentlocation != null) {
                            skyward.controls.setValue(studentLocationLabel, data.studentlocation);
                        }
                    }
                });

                studentPopupButton.data('id', studentID);
                studentPopupButton.data('primarykey', studentID);
                studentPopupButton.data('title', studentName);

                skyward.controls.show('studentLocationLabel');
                skyward.controls.show('btnStudentInformationPopup');
                skyward.controls.show('btnAddToInOffice');
                skyward.controls.show('btnAddToWaitingList');
            }
            else {
                studentPopupButton.data('id', '');
                studentPopupButton.data('primarykey', '');
                studentPopupButton.data('title', '');

                skyward.controls.hide('studentLocationLabel');
                skyward.controls.hide('btnStudentInformationPopup');
                skyward.controls.hide('btnAddToInOffice');
                skyward.controls.hide('btnAddToWaitingList');
            }

            resizeOfficeVisitQueueBrowse();
        };

        skyward.officevisit.addtoinofficequeue = function ()
        {
            var clickedButton = $(this);
            saveOfficeVisitQueue(clickedButton, "AddToInOffice");
        };

        skyward.officevisit.addtowaitinglistqueue = function ()
        {
            var clickedButton = $(this);
            saveOfficeVisitQueue(clickedButton, "AddToWaiting");
        };

        var saveOfficeVisitQueue = skyward.buttonManager.manageButtonClick(function (clickedButton, action)
        {
            var parentDiv = clickedButton.parent('div');
            var primaryKey;
            var controller;
            if (Module == "Guidance")
            {
                primaryKey = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_value'));
                controller = "StudentOfficeVisit";
            }
            else
            {
                var nameOfficeVisitFilterOption = skyward.controls.getValue('#NameOfficeVisitFilterOption');
                if (nameOfficeVisitFilterOption == 'STU')
                {
                    primaryKey = skyward.controls.getValue('input#studentSelectorTileViewEEL_value');
                }
                else if (nameOfficeVisitFilterOption == 'STF')
                {
                    primaryKey = skyward.controls.getValue('input#staffSelectorTileViewEEL_value');
                }
                
                controller = "NameOfficeVisit";
            }
            var isDetailsPanelOpen = $('html').find('#detailsPanel').length > 0;

            return $.ajax({
                url: skyward.global.virtualDir + Module + "/" + controller + "/OfficeVisitQueue" + action + "/",
                type: "POST",
                dataType: "JSON",
                data: { primarykey: primaryKey, nameOfficeVisitFilterOption: nameOfficeVisitFilterOption },
                success: function (data)
                {
                    if (data && data.success)
                    {
                        if (!isDetailsPanelOpen)
                        {
                            skyward.window.loadContent('full', Module, controller, 'Details', data.primarykey);
                        }
                        else
                        {
                            skyward.window.loadContent('full', Module, controller, 'OfficeVisitQueue');
                        }
                    }
                    else
                    {
                        var officeVisitSelector = clickedButton.parents();
                        var officeVisitErrorSelector = officeVisitSelector.find('#officeVisitQueueErrors');
                        skyward.validation.displayValidationMessages(data, officeVisitSelector, officeVisitErrorSelector, null, null);
                    }
                }
            });
        });

        var resizeOfficeVisitQueueBrowse = function ()
        {
            var parent = $("html").find("#moduleContent");
            var officeVisitQueueBrowse = parent.find('#OfficeVisitQueueBrowse');
            var officeVisitQueueControls = parent.find('div.officevisitqueue');

            if (officeVisitQueueControls.length > 0)
            {
                var controlsHeight = officeVisitQueueControls.outerHeight(true);

                var innerHeight = parent.height() - controlsHeight - 10;
                if (innerHeight > 0)
                {
                    officeVisitQueueBrowse.innerHeight(innerHeight);
                }
            }
        };

        skyward.officevisit.rowMenuButton = function ()
        {
            var parentDiv = $(this).parent('div');

            var controller;
            var primaryKey;
            if (Module == "Guidance") {
                controller = "StudentOfficeVisit";
                primaryKey = $(this).data().studentofficevisitid;
            }
            else {
                controller = "NameOfficeVisit";
                primaryKey = $(this).data().nameofficevisitid;
            }

            return $.ajax({
                url: skyward.global.virtualDir + Module + "/" + controller + "/" + controller + "RowMenuControls/" + primaryKey,
                type: "POST",
                dataType: "JSON",
                data: $(this).data(),
                success: function (data) {
                    if (data && data.success) {
                        skyward.window.loadContent('full', Module, controller, data.redirect, data.id);
                    }
                    else {
                        var officeVisitSelector = $('.officevisitqueue');
                        var officeVisitErrorSelector = officeVisitSelector.find('#officeVisitQueueErrors');
                        skyward.validation.displayValidationMessages(data, officeVisitSelector, officeVisitErrorSelector, null, null);
                    }
                }
            });
        };        

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

        var events =
        {
            'rowMenuButton': skyward.officevisit.rowMenuButton
        };

        skyward.events.registerEvents('officevisit', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
